import React, { useState } from 'react';
import {
  COMPANY,
  DEFAULT_ACCESS_CODE,
  ACCESS_STORAGE_KEY,
  INVOICE_CSS
} from '../../utils/pejmanInvoice';
import InstallBanner from './InstallBanner';

const AccessGate = ({ onUnlock }) => {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setBusy(true);
    setError('');
    const entered = String(code || '').trim();
    if (entered && entered === String(DEFAULT_ACCESS_CODE).trim()) {
      sessionStorage.setItem(ACCESS_STORAGE_KEY, '1');
      onUnlock();
      return;
    }
    setError('Incorrect access code. Try again.');
    setBusy(false);
  };

  return (
    <div
      className="pejman-app flex flex-col items-center justify-center px-5 py-10"
      style={{
        background: `linear-gradient(165deg, ${INVOICE_CSS.background} 0%, #E8EEF4 45%, #DCE6F0 100%)`,
        paddingTop: 'max(2.5rem, env(safe-area-inset-top))',
        paddingBottom: 'max(2.5rem, env(safe-area-inset-bottom))'
      }}
    >
      <div className="w-full max-w-sm [&:has(.pejman-install)]:mb-3">
        <InstallBanner />
      </div>
      <div className="w-full max-w-sm bg-white rounded-2xl shadow-lg border border-slate-200/80 overflow-hidden">
        <div className="px-6 pt-8 pb-6 text-center border-b" style={{ borderColor: INVOICE_CSS.border }}>
          <img
            src={COMPANY.logoUi}
            alt={COMPANY.name}
            width={220}
            height={88}
            fetchPriority="high"
            className="mx-auto h-16 w-auto max-w-[220px] object-contain"
          />
          <p
            className="mt-4 text-[11px] font-semibold uppercase tracking-[0.12em]"
            style={{ color: INVOICE_CSS.muted }}
          >
            Field invoicing
          </p>
          <h1
            className="mt-1 text-xl font-semibold tracking-tight text-pretty"
            style={{ color: INVOICE_CSS.primary }}
          >
            Pejman
          </h1>
          <p className="text-sm mt-1" style={{ color: INVOICE_CSS.muted }}>
            Invoice &amp; Estimate
          </p>
        </div>
        <form onSubmit={handleSubmit} className="px-6 py-7 space-y-4">
          <div>
            <label
              htmlFor="pejman-code"
              className="block text-sm font-medium mb-2"
              style={{ color: INVOICE_CSS.foreground }}
            >
              Access code
            </label>
            <input
              id="pejman-code"
              name="accessCode"
              type="password"
              inputMode="text"
              autoComplete="one-time-code"
              spellCheck={false}
              value={code}
              onChange={(e) => {
                setCode(e.target.value);
                if (error) setError('');
              }}
              placeholder="Enter code…"
              className="w-full min-h-[48px] px-4 rounded-xl border text-base focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-1 focus-visible:ring-[#012E53]"
              style={{
                borderColor: INVOICE_CSS.border,
                color: INVOICE_CSS.foreground
              }}
            />
          </div>
          {error ? (
            <p className="text-sm" style={{ color: INVOICE_CSS.destructive }} role="alert">
              {error}
            </p>
          ) : null}
          <button
            type="submit"
            disabled={busy || !code.trim()}
            className="w-full min-h-[48px] rounded-xl text-white font-semibold text-base disabled:opacity-50 active:scale-[0.99] transition-opacity duration-200 cursor-pointer focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-[#012E53]"
            style={{ background: INVOICE_CSS.primary }}
          >
            {busy ? 'Checking…' : 'Enter'}
          </button>
          <p className="text-center text-xs pt-1" style={{ color: INVOICE_CSS.muted }}>
            {COMPANY.name}
          </p>
        </form>
      </div>
    </div>
  );
};

export default AccessGate;
